<template>
  <el-dialog
      title="批量设置佣金"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="400px"
  >
    <template #default>
      <div style="display: flex;gap: 10px;align-items: center;">
        <div style="width: 150px">
          佣金比例：
        </div>
        <el-input v-model="rate" placeholder="请输入佣金比例" @input="handleInput"/>
      </div>
    </template>
    <template #footer>
      <div style="display: flex;justify-content: flex-end;gap: 10px;">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {formatPositiveIntegerInput} from "../../../../../utils/regExp";

export default {
  data() {
    return {
      dialogVisible: false,
      rate: null
    };
  },
  methods: {
    handleInput(value){
      this.$nextTick(()=>{
        this.rate = formatPositiveIntegerInput(value)
      })
    },
    handleClose(){
      this.rate = null;
      this.dialogVisible = false;
    },
    handleConfirm(){
      if(!this.rate){
        this.$message.error('请输入佣金比例，范围1-29的整数')
        return;
      }

      if(this.rate < 1 || this.rate > 29){
        this.$message.error('请输入佣金比例，范围1-29的整数')
        return;
      }

      this.$emit('handleUpdateRate',this.rate)
      this.handleClose()
    },
    open(){
      this.dialogVisible = true;
    }
  }
};
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/mulSetCommissionRate.vue